export default {
  login: '/auth/login',
  checkAuthCode: '/auth/check-auth-code',
  forgotPassword: '/auth/forgot-password',
  changePassword: '/auth/change-password',
  confirmInvite: '/auth/confirm-invite',
  checkCode: '/users/check-code',
  currentUser: '/auth/current',
  logout: '/auth/logout',
  roles: '/roles',
  permissions: '/permissions',
  users: '/users',
  createInvite: '/users/create-invite',
  languages: '/languages',
  menus: '/menus',
  widgets: '/widgets',
  widgetsFiles: '/widgets-files',
  translations: '/translations',
  brands: '/brands',
  slides: '/slides',
  pages: '/pages',
  feedback: '/feedback',
  posts: '/posts',
  solutions: '/solutions',
  damages: '/damages',
  postsCategories: '/posts-categories',
  vacancies: '/vacancies',
  teamMembers: '/team-members',
  upload: '/temp-files/upload',
  metaData: '/meta-data',
  deleteTempFile: '/temp-files/delete',
  settings: '/settings',
  updateSitemap: '/settings/sitemap',
  emptyCoversDirectory: '/settings/emptyCovers',
  slash: '/',
  projects: '/projects',
  projectSections: '/project-sections',
  projectsCategories: '/projects-categories',
  projectTags: '/project-tags',
  projectHashtags: '/project-hashtags',
  projectsItems: '/projects-items',
  projectTypes: '/project-types',
  projectTypesItems: '/project-types-items',
  testMailjet: '/test-mailjet',
  positions: '/positions',
  team: '/team',
  images: '/images',
  blackIps: '/black-ips',
};



// WEBPACK FOOTER //
// ./src/services/api.routes.js